import { Component, OnInit, inject } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { AppBasicsService, MfCommonAuthModule } from '@meddev/fe-shared';
import { Store } from '@ngxs/store';
import { LoaderService } from './_common/services/loader.service';
import { RulesService } from './_common/services/rules.service';
import { BaseState } from './_common/state/base/base.state';
import { MenuStateActions } from './_common/state/menu/menu.actions';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [MfCommonAuthModule, RouterOutlet],
})
export class AppComponent implements OnInit {
    private rules = inject(RulesService);
    private store = inject(Store);
    router = inject(Router);
    private loader = inject(LoaderService);
    private appBasics = inject(AppBasicsService);

    constructor() {
        this.router.events?.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.loader.setLoading(true);
            }
            if (event instanceof NavigationEnd) {
                this.loader.setLoading(false);
            }
        });

        const bs = this.store.selectSnapshot(BaseState.getBS);

        if (bs.id) {
            this.appBasics.setBusinessSubject(bs);
        }
        const user = this.store.selectSnapshot(BaseState.getUser);
        if (user) {
            this.appBasics.setUser(user);
        }
    }
    title = 'preventivni';
    ngOnInit() {
        this.rules.setRules();
        this.store.dispatch(new MenuStateActions.ClearHeaderData());
    }
}
